import React from 'react';
import libroImg from '../../../assets/img/desktop/libro-de-reclamaciones-transparent.png';
import './LibroReclamacionesBadge.css';

interface LibroReclamacionesBadgeProps {
    variant?: 'card' | 'compact' | 'floating';
    className?: string;
}

const RECLAMO_URL = 'https://app.reclamovirtual.pe/reclamar/infrasol/miraflores';

export const LibroReclamacionesBadge: React.FC<LibroReclamacionesBadgeProps> = ({
    className = ''
}) => {
    return (
        <a 
            href={RECLAMO_URL} 
            target="_blank" 
            rel="noopener noreferrer"
            className={`lrb-image-badge ${className}`} 
            title="Libro de Reclamaciones - Infrasol Miraflores"
            aria-label="Abrir Libro de Reclamaciones"
        >
            <img 
                src={libroImg} 
                alt="Libro de Reclamaciones" 
                className="lrb-img"
            />
        </a>
    );
};

export default LibroReclamacionesBadge;
